export const simplifiedServiceModesForSupport = ['pickUp', 'delivery', 'notApplicable'];
